export default __webpack_public_path__ + "static/tabsSectionBg-0a75e8fa8e8880f8476ebcf906a5e228.png";